import React, { createContext, useContext, useEffect, useState } from "react";

const ShopCtx = createContext();
export const useShop = () => useContext(ShopCtx);

export const COUNTRIES = [
  { code: "ET", name: "Ethiopia", flag: "🇪🇹", market: "ethiopia", currency: "ETB" },
  { code: "US", name: "United States", flag: "🇺🇸", market: "global", currency: "USD" },
  { code: "CA", name: "Canada", flag: "🇨🇦", market: "global", currency: "USD" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧", market: "global", currency: "USD" },
  { code: "EU", name: "Europe", flag: "🇪🇺", market: "global", currency: "USD" },
  { code: "AU", name: "Australia", flag: "🇦🇺", market: "global", currency: "USD" },
  { code: "OT", name: "Other", flag: "🌍", market: "global", currency: "USD" },
];

export function ShopProvider({ children }) {
  const [region, setRegion] = useState(COUNTRIES[1]);
  const [cart, setCart] = useState([]);

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("refugium_region"));
      if (saved) setRegion(saved);
      else {
        fetch("https://ipapi.co/json/").then((r) => r.json()).then((d) => {
          const match = COUNTRIES.find((c) => c.code === d.country_code) || (d.country_code === "ET" ? COUNTRIES[0] : null);
          if (match) chooseRegion(match);
        }).catch(() => {});
      }
    } catch { /* noop */ }
    try { const c = JSON.parse(localStorage.getItem("refugium_cart")); if (Array.isArray(c)) setCart(c); } catch { /* noop */ }
    // eslint-disable-next-line
  }, []);

  const chooseRegion = (c) => { setRegion(c); localStorage.setItem("refugium_region", JSON.stringify(c)); };
  const persist = (c) => { setCart(c); localStorage.setItem("refugium_cart", JSON.stringify(c)); };

  const price = (p) => (region.market === "ethiopia" ? p.price_eth : p.price_intl) || 0;
  const linePrice = (c) => (region.market === "ethiopia" ? c.price_eth : c.price_intl) || 0;
  const fmt = (n) => (region.market === "ethiopia" ? `ETB ${Number(n || 0).toLocaleString()}` : `$${Number(n || 0).toFixed(0)}`);
  const priceLabel = (p) => { const v = price(p); return v > 0 ? fmt(v) : "Price coming soon"; };
  const img = (p) => {
    if (!p) return "";
    if (region.market === "ethiopia") return p.image_eth_main || p.image_global_main || p.images?.[0] || "";
    return p.image_global_main || p.images?.[0] || "";
  };
  const gallery = (p) => {
    if (!p) return [];
    const base = region.market === "ethiopia"
      ? [p.image_eth_main, ...(p.images_eth || [])]
      : [p.image_global_main, ...(p.images_global || [])];
    const all = [...base, ...(p.images || [])].filter(Boolean);
    return [...new Set(all)];
  };

  const addToCart = (item) => {
    const idx = cart.findIndex((c) => c.product_id === item.product_id && c.size === item.size && c.color === item.color);
    if (idx >= 0) { const next = [...cart]; next[idx].qty += item.qty; persist(next); }
    else persist([...cart, item]);
  };
  const updateQty = (i, q) => { const next = [...cart]; next[i].qty = Math.max(1, q); persist(next); };
  const removeFromCart = (i) => persist(cart.filter((_, x) => x !== i));
  const clearCart = () => persist([]);

  const cartCount = cart.reduce((a, c) => a + c.qty, 0);
  const subtotal = cart.reduce((a, c) => a + linePrice(c) * c.qty, 0);

  return (
    <ShopCtx.Provider value={{ region, chooseRegion, cart, addToCart, updateQty, removeFromCart, clearCart, cartCount, subtotal, price, linePrice, fmt, priceLabel, img, gallery, COUNTRIES }}>
      {children}
    </ShopCtx.Provider>
  );
}
